// IMPORT IMAGES
import PERSON_PHOTO from './images/photo.JPG';
import LOGO from './images/logo.jpg';
import TAGS from './images/tages.svg';
import ABOUT_ME_IMG from './images/about_img.jpeg';
import BLOG_IMG from './images/blog_img.jpeg';
import CONSULT_IMG from './images/consult_img.jpeg';

//DATE
const YEAR = 2020;
const CURRENT_YEAR = new Date().getFullYear();
const FOOTER_YEAR = CURRENT_YEAR === YEAR ? `${YEAR}` : `${YEAR}-${CURRENT_YEAR}`

//DECOR
const DECOR = {
  logo : {
    img: LOGO,
    alt: 'Дерево жизни с мощными корнями и листьями нескольких оттенков зеленого'
  },
  tages: {
    img: TAGS,
    alt: 'Фигура из овальных лепестков, на которых есть слова: Личность, взрослые, подростки, семья, отношения'
  },
}

//PERSONAL INFO
const PERSON = {
  photo: PERSON_PHOTO,
  prof : 'Психолог',
  lastname : 'Флоренская',
  name : 'Вероника Викторовна',
  phone : '+7 912 24-34-390',
  messengers: '79122434390'
}

const CONTENT = {
  aboutMe : {
    title: "Обо мне",
    imgLink : ABOUT_ME_IMG,
    imgAlt : 'Полки с книгами',
    point: 'Психолог c\u00A0опытом более\u00A020\u00A0лет',
    text:

`23 года практики в семейном и персональном психологическом консультировании (преодоление межличностной дисгармонии, кризисных и стрессовых ситуаций, поддержка в сфере родительской самореализации).
\nОтдаю предпочтение методам когнитивной психотерапии, системному подходу в работе с семьями (парами).
\nЗакончила Уральский государственный университет им. А. М. Горького в 2000 г. по специальности «Психология», в 1996 г. по специальности «Культурология». В этом же университете защитила диссертацию в 2010 г., присвоена учёная степень кандидата культурологии.`,
  },

  blog : {
    cardColor: '#3CC684',
    title: "Мой блог",
    imgLink : BLOG_IMG,
    imgForm: 'smallRound',
    point: 'Статьи психолога по\u00A0тематике обращений:',
    text:
`\u2022 работа над осознанным партнёрством\u00A0/\u00A0супружеством
\u2022 родительская самореализация, детско-родительские отношения
\u2022 преодоление детских травм у взрослых
\u2022 преобразование невротических взаимоотношений в поддержку и близость на основе понимания типа привязанности партнёров\u00A0/\u00A0супругов
\u2022 поддержка со стороны семьи ребёнка-школьника с трудностями в учёбе и социальной адаптации
\u2022 экзистенциальные / возрастные кризисы
\u2022 стрессовое реагирование`,
    imgAlt : 'Полки с книгами'
  },

  consult : {
    cardColor: '#FFB549',
    title: "Запись на\u00A0консультацию",
    point: 'Телеграм\nWhatsApp',
    imgForm: 'round',
    imgLink : CONSULT_IMG,
    imgAlt : 'Консультация психолога в его кабинете',
    text: `Записаться на консультацию можно написав сообщение в мессенджерах Telegram или WhatsApp, либо СМС
    по номеру +7 912 24-34-390.

Продолжительность консультации: 70 минут.

Формат консультации: видео, аудио.

Возможен формат очной консультации.`,
    accent: '+7 912 24-34-390',
  },
}

export {
  PERSON,
  DECOR,
  CONTENT,
  FOOTER_YEAR
};
